unit UFakList;

interface

uses
  System.Contnrs, UFakModel, Js, UEssentialHelper;

type
  TFakList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    FOnError: TErrorEvent;
    function GetItem(i: Integer): TFakModel;
    procedure DoError(AMsg: string);
    procedure PropertyChanged;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetOnError(const Value: TErrorEvent);
  public
    constructor Create;
    function IndexOf(Value: string): Integer;
    procedure Add(item: TFakModel);
    procedure GetAll(url: string; pattern: string);
    procedure SetValues(json: string); overload;
    property Items[i: Integer]: TFakModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  System.SysUtils, WebLib.REST, WebLib.json, WebLib.Controls, WebLib.Storage;

{ TFakList }

procedure TFakList.Add(item: TFakModel);
begin
  inherited Add(item);
end;

constructor TFakList.Create;
begin
  inherited Create;
  Self.OnPropertyChanged := nil;
  Self.OnError := nil;
end;

procedure TFakList.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TFakList.GetAll(url: string; pattern: string);
var
  client: TRestClient;
  obj: TJsonObject;
  helper, cmd: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TFakList.GetAll');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('pattern', pattern);
  helper := obj.ToString;
  cmd := url + '/FakService/GetAll_' + helper;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(url + '/FakService/GetAll', 'application/json',
    obj.ToString);
end;

function TFakList.GetItem(i: Integer): TFakModel;
begin
  Result := inherited GetItem(i) as TFakModel;
end;

function TFakList.IndexOf(Value: string): Integer;
var
  nr, bez: string;
  i: Integer;
  found: Boolean;
begin
  nr := Cut(Value);
  bez := Cut(Value);
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if (Self.Items[i].nr = nr) and (Self.Items[i].Bezeichnung = bez) then
      found := true
    else
      Inc(i);
  if found then
    Result := i
  else
    Result := -1;
end;

procedure TFakList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TFakList.SetValues(obj: TJsObject);
var
  i, Count: Integer;
begin
  Self.Clear;
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TFakModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
end;

procedure TFakList.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TFakList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TFakList.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

end.
